import { AbstractEntity } from './AbstractEntity';
export class VersionedAbstractEntity extends AbstractEntity {
    successor;
    constructor(id) {
        super(id);
    }
}
//# sourceMappingURL=VersionedAbstractEntity.js.map